export default {"src":"/customer-services/_next/static/media/small-appliances.e8bf010c.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};